import qs from 'qs'
import * as axiosHelper from './api_helper'
import HTXClient from './htx/HTXClient'

export const fetchMarkets = async ({ payload }) => {
  const data = await axiosHelper.get(
    `/markets/markets/all?${qs.stringify(payload)}`,
  )
  if (data.isError) {
    return data
  }
  return data.result
}
export const fetchSpecificMarket = async (pairName) => {
  const data = await axiosHelper.get(
    `/markets/pair/${pairName}`,
  )
  if (data.isError) {
    return data
  }
  return data.result
}

export const updateFavorite = async ({ payload }) => {
  const { id, ...rest } = payload
  const data = await axiosHelper.patch(`pricing/${id}`, rest)
  if (!data.result) throw new Error(data.message)
  return data.result
}

// Initialize HTX client instance
const htxClient = new HTXClient()

export const fetchPricingPairs = async (markets = []) => {
  try {
    // Extract pair names from markets data
    const pairNames = markets.map(market => market.pairName).filter(Boolean)
    
    if (pairNames.length === 0) {
      return {
        success: true,
        data: [],
      }
    }

    // Fetch pricing data from HTX
    const pricingResponse = await htxClient.getPricingForPairs(pairNames)
    
    if (!pricingResponse.success) {
      console.error('Failed to fetch pricing from HTX:', pricingResponse.error)
      return {
        success: false,
        error: pricingResponse.error,
        data: [],
      }
    }

    return {
      success: true,
      data: pricingResponse.data,
    }
  } catch (error) {
    console.error('Error in fetchPricingPairs:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch pricing pairs',
      data: [],
    }
  }
}
